import React, { useEffect, useState } from 'react';
import { Card } from 'primereact/card';
import { Chart } from 'primereact/chart';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ProgressBar } from 'primereact/progressbar';
import { Avatar } from 'primereact/avatar';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { useSearchParams } from 'react-router-dom';
import { handleGetRequest } from '../../services/GetTemplate';

export default function Dashboard() {

    const [reportsData, setReportsData] = useState()
    const [loading, setLoading] = useState(false)
    const [cardData, setCardData] = useState()
    const [userRole, setUserRole] = useState('')

    // Get user role from localStorage
    useEffect(() => {
        const role = localStorage.getItem('roleName');
        setUserRole(role || '');
    }, []);

    // Fetch data when userRole changes
    useEffect(() => {
        const fetchData = async () => {
            if (!userRole) return;
            
            setLoading(true);
            
            // Determine endpoint based on user role
            let endpoint = '/api/report/fitness/year'; // Default to fitness endpoint
            
            if (userRole.toLowerCase().includes('fitness')) {
                endpoint = '/api/report/fitness/year';
            } else if (userRole.toLowerCase().includes('deputy director') || 
                     userRole.toLowerCase().includes('data entry')) {
                endpoint = '/api/report/permit/year';
            }
            
            console.log(`Fetching data for role: ${userRole} from endpoint: ${endpoint}`);
            const response = await handleGetRequest(endpoint, false);

            if (response?.success === true) {
                const mappedData = response?.data?.map((item) => {
                    return {
                        totalRequests: item?.totalRequests, // Ensure consistent property name
                        requestCount: item?.totalRequests,
                        requestDate: item?.monthName,
                        onlinePayments: item?.onlinePayments,
                        batchPayments: item?.batchPayments,
                        renewedRequests: item?.renewedRequests,
                        newRequests: item?.newRequests,
                        totalExpired: item?.totalExpired,
                        totalRevenue: item?.totalRevenue,
                        approvedCertificates: item?.totalApproved,
                        rejectedCertificates: item?.totalRejected
                    };
                });
                
                setReportsData(mappedData);
                
                // Update card data with the first item from the response if available
                if (response.data && response.data.length > 0) {
                    setCardData([response.data[0]]);
                }
            }
            
            setLoading(false);
        };
        
        fetchData();
    }, [userRole])
  

    const lastWeekReportLabels = reportsData?.map((item) => item?.requestDate);

   const lineChartData = {
       labels: lastWeekReportLabels,
       datasets: [
           {
               label: 'Total Requests',
               data: reportsData?.map((item) => Number(item?.totalRequests) || 0),
               borderColor: '#0488fcff', // Blue for better visibility
               backgroundColor: 'rgba(4, 136, 252)', // Light blue background
               fill: false,
               tension: 0.4,
               borderWidth: 3, // Even thicker line
               pointRadius: 4, // Even larger points
            //    pointHoverRadius: 10,
            //    pointBackgroundColor: '#424242', // Make points visible
            //    pointBorderColor: '#ffffff',
            //    pointBorderWidth: 3,
            //    hidden: false, // Explicitly show this dataset
               order: 0 // Ensure it renders on top of other datasets
           },
           {
               label: 'Renewed Requests',
               data: reportsData?.map((item) => item?.renewedRequests),
               borderColor: '#673AB7', // Deep Purple
               backgroundColor: 'rgba(103, 58, 183)', // Same as borderColor with transparency
               fill: false,
               tension: 0.4,
               borderWidth: 3,
               pointRadius: 4,
               pointHoverRadius: 6
           },
           {
               label: 'New Requests',
               data: reportsData?.map((item) => item?.newRequests),
               borderColor: '#2196F3', // Blue
               backgroundColor: 'rgba(33, 150, 243)', // Same as borderColor with transparency
               fill: false,
               tension: 0.4,
               borderWidth: 3,
               pointRadius: 4,
               pointHoverRadius: 6
           },
           
           {
               label: 'Approved Certificates',
               data: reportsData?.map((item) => item?.approvedCertificates),
               borderColor: '#4CAF50', // Green (appropriate for approval)
               backgroundColor: 'rgba(76, 175, 80)', // Same as borderColor with transparency
               fill: false,
               tension: 0.4,
               borderWidth: 3,
               pointRadius: 4,
               pointHoverRadius: 6
           },
           {
               label: 'Expired Certificates',
               data: reportsData?.map((item) => item?.totalExpired),
               borderColor: '#FF9800', // Orange
               backgroundColor: 'rgba(255, 152, 0)', // Same as borderColor with transparency
               fill: false,
               tension: 0.4,
               borderWidth: 3,
               pointRadius: 4,
               pointHoverRadius: 6
           },
           {
               label: 'Rejected Certificates',
               data: reportsData?.map((item) => item?.rejectedCertificates),
               borderColor: '#F44336', // Red (appropriate for rejection)
               backgroundColor: 'rgba(244, 67, 54)', // Same as borderColor with transparency
               fill: false,
               tension: 0.4,
               borderWidth: 3,
               pointRadius: 4,
               pointHoverRadius: 6
           }
       ]
    };
     const secondLineChartData = {
         labels: lastWeekReportLabels,
         datasets: [
            //  {
            //      label: 'Total Payments',
            //      data: reportsData?.map((item) => item?.totalRequests),
            //      borderColor: '#3F51B5', // Indigo (money color)
            //      backgroundColor: 'rgba(63, 81, 181)', // Same as borderColor with transparency
            //      fill: false,
            //      tension: 0.4,
            //      borderWidth: 3,
            //      pointRadius: 4,
            //      pointHoverRadius: 6
            //  },
             {
                 label: 'Online Payments',
                 data: reportsData?.map((item) => item?.onlinePayments),
                 borderColor: '#00BCD4', // Cyan (online/digital color)
                 backgroundColor: 'rgba(0, 188, 212)', // Same as borderColor with transparency
                 fill: false,
                 tension: 0.4,
                 borderWidth: 3,
                 pointRadius: 4,
                 pointHoverRadius: 6
             },
             {
                 label: 'Batch Payments',
                 data: reportsData?.map((item) => item?.batchPayments),
                 borderColor: '#795548', // Brown (batch/paper color)
                 backgroundColor: 'rgba(121, 85, 72)', // Same as borderColor with transparency
                 fill: false,
                 tension: 0.4,
                 borderWidth: 3,
                 pointRadius: 4,
                 pointHoverRadius: 6
             }
         ]
     };
    // Get dynamic chart titles based on user role
    const getChartTitle = () => {
        if (userRole.toLowerCase().includes('fitness')) {
            return 'Monthly Fitness Certificate Requests Trend';
        } else if (userRole.toLowerCase().includes('deputy director') || 
                  userRole.toLowerCase().includes('data entry')) {
            return 'Monthly Route Permit Requests Trend';
        }
        return 'Monthly Requests Trend';
    };

    const getPaymentsTitle = () => {
        if (userRole.toLowerCase().includes('fitness')) {
            return 'Monthly Fitness Certificate Payments Trend';
        } else if (userRole.toLowerCase().includes('deputy director') || 
                  userRole.toLowerCase().includes('data entry')) {
            return 'Monthly Route Permit Payments Trend';
        }
        return 'Monthly Payments Trend';
    };

    const lineChartOptions = {
        plugins: {
            legend: {
                labels: {
                    color: '#212121',
                    font: {
                        size: 12,
                        weight: 'bold'
                    }
                }
            },
            tooltip: {
                backgroundColor: 'white',
                titleColor: '#212121',
                titleFont: {
                    size: 13,
                    weight: 'bold'
                },
                bodyColor: '#212121',
                bodyFont: {
                    size: 12
                },
                borderColor: '#ddd',
                borderWidth: 1
            },
            title: {
                display: true,
                text: getChartTitle(),
                color: '#212121',
                font: {
                    size: 16,
                    weight: 'bold'
                },
                padding: {
                    top: 10,
                    bottom: 10
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#212121',
                    font: {
                        size: 12
                    }
                },
                grid: {
                    color: '#ebedef'
                },
                title: {
                    display: true,
                    text: 'Month',
                    color: '#212121',
                    font: {
                        size: 13,
                        weight: 'bold'
                    }
                }
            },
            y: {
                ticks: {
                    color: '#212121',
                    font: {
                        size: 12
                    }
                },
                grid: {
                    color: '#ebedef'
                },
                title: {
                    display: true,
                    text: 'Number of Requests',
                    color: '#212121',
                    font: {
                        size: 13,
                        weight: 'bold'
                    }
                }
            }
        }
    };



    return (
        <div className="grid p-fluid">
            {/* {cardData && cardData[0] && (
                <>
                    <div className="col-12 md:col-4">
                        <Card title="Total Trials" subTitle={`${cardData[0]?.totalRequests}`} />
                    </div>
                    <div className="col-12 md:col-4">
                        <Card title="Late Registrations" subTitle={`${cardData[0]?.lateRegisterations}`} />
                    </div>
                    <div className="col-12 md:col-4">
                        <Card title="Trials in Progress" subTitle={`${cardData[0]?.pendingCount}`} />
                    </div>
                    <div className="col-12 md:col-4">
                        <Card title="Trials Approved" subTitle={`${cardData[0]?.approvedCount}`} />
                    </div>
                    <div className="col-12 md:col-4">
                        <Card title="Trials Completed" subTitle={`${cardData[0]?.completedCount}`} />
                    </div>
                    <div className="col-12 md:col-4">
                        <Card title="Trials Rejected" subTitle={`${cardData[0]?.rejectedCount}`} />
                    </div>
                    <div className="col-12 md:col-4">
                        <Card title="Approved Certificates" subTitle={`${cardData[0]?.approvedCertificates?.toLocaleString() || 0}`} />
                    </div>
                    <div className="col-12 md:col-4">
                        <Card title="Rejected Certificates" subTitle={`${cardData[0]?.rejectedCertificates?.toLocaleString() || 0}`} />
                    </div>
                </>
            )} */}

            <div className="col-12">
                <Card  style={{ padding: 0 }}>
                    <div
                        style={{
                            position: 'relative',
                            height: '450px',
                            padding: '0.5rem 1rem 1rem'
                        }}
                    >
                        {loading ? (
                            <div className="flex align-items-center justify-content-center" style={{ height: '450px' }}>
                                <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
                                <span className="ml-2">Loading chart data...</span>
                            </div>
                        ) : !reportsData || reportsData.length === 0 ? (
                            <div className="flex align-items-center justify-content-center" style={{ height: '450px' }}>
                                <span>No chart data available</span>
                            </div>
                        ) : (
                            <Chart
                                type="line"
                                data={lineChartData}
                                height="450px"
                                options={{
                                    ...lineChartOptions,
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        ...lineChartOptions.plugins,
                                        legend: {
                                            ...lineChartOptions.plugins?.legend,
                                            position: 'top'
                                        },
                                        title: {
                                            ...lineChartOptions.plugins.title,
                                            text: getChartTitle()
                                        }
                                    },
                                    scales: {
                                        ...lineChartOptions.scales,
                                        y: {
                                            ...lineChartOptions.scales.y,
                                            title: {
                                                ...lineChartOptions.scales.y.title,
                                                text: 'Number of Requests'
                                            },
                                            min: 0,
                                            ticks: {
                                                ...lineChartOptions.scales.y.ticks,
                                                stepSize: 1,
                                                precision: 0
                                            }
                                        }
                                    }
                                }}
                            />
                        )}
                    </div>
                </Card>
            </div>
            <div className="col-12">
                <Card  style={{ padding: 0 }}>
                    <div
                        style={{
                            position: 'relative',
                            height: '450px',
                            padding: '0.5rem 1rem 1rem'
                        }}
                    >
                        {loading ? (
                            <div className="flex align-items-center justify-content-center" style={{ height: '450px' }}>
                                <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
                                <span className="ml-2">Loading chart data...</span>
                            </div>
                        ) : !reportsData || reportsData.length === 0 ? (
                            <div className="flex align-items-center justify-content-center" style={{ height: '450px' }}>
                                <span>No chart data available</span>
                            </div>
                        ) : (
                            <Chart
                                type="line"
                                data={secondLineChartData}
                                height="450px"
                                options={{
                                    ...lineChartOptions,
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        ...lineChartOptions.plugins,
                                        legend: {
                                            ...lineChartOptions.plugins?.legend,
                                            position: 'top'
                                        },
                                        title: {
                                            ...lineChartOptions.plugins.title,
                                            text: getPaymentsTitle()
                                        }
                                    },
                                    scales: {
                                        ...lineChartOptions.scales,
                                        y: {
                                            ...lineChartOptions.scales.y,
                                            title: {
                                                ...lineChartOptions.scales.y.title,
                                                text: 'Number of Payments'
                                            },
                                            min: 0,
                                            ticks: {
                                                ...lineChartOptions.scales.y.ticks,
                                                stepSize: 1,
                                                precision: 0
                                            }
                                        }
                                    }
                                }}
                            />
                        )}
                    </div>
                </Card>
            </div>
        </div>
    );
}